import type { Transaction } from 'types/api/transaction';

export const DOTONE_CELL_ADDRESS = '0xC78a21DbaC9EDa7f48b1eA19B22cC9F13C221E79';
export const DOTONE_CELL_LOGOS = {
  light: '/assets/cell-logo-light.png',
  dark: '/assets/cell-logo-dark.png',
};

export const isDotoneCellAddress = (address?: string | null) =>
  Boolean(address && address.toLowerCase() === DOTONE_CELL_ADDRESS.toLowerCase());

export const isDotoneCellTransaction = (tx: Pick<Transaction, 'from' | 'to' | 'created_contract' | 'token_transfers'>) =>
  isDotoneCellAddress(tx.from?.hash) ||
  isDotoneCellAddress(tx.to?.hash) ||
  isDotoneCellAddress(tx.created_contract?.hash) ||
  Boolean(tx.token_transfers?.some(({ token }) => isDotoneCellAddress(token?.address_hash)));
